var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3762 9.80687H3.62254C3.39546 9.80687 3.18426 9.74095 3.0109 9.6152C2.84853 9.498 2.72522 9.32952 2.66662 9.14151C2.5482 8.76916 2.68737 8.37605 3.02188 8.14164L5.90918 6.11016C6.12405 5.95878 6.36944 5.85989 6.6307 5.81594C6.69662 5.49974 6.94201 5.25801 7.14589 5.05779C7.20205 5.00286 7.25455 4.95036 7.30094 4.89909C7.37785 4.81485 7.42058 4.70253 7.42058 4.58167C7.42058 4.32163 7.17031 4.11042 6.86144 4.11042C6.55256 4.11042 6.30229 4.32163 6.30229 4.58167C6.30229 4.75014 6.16555 4.88688 5.99708 4.88688C5.8286 4.88688 5.69187 4.75014 5.69187 4.58167C5.69187 3.98467 6.21683 3.5 6.86144 3.5C7.50604 3.5 8.031 3.9859 8.031 4.58167C8.031 4.85636 7.93089 5.11517 7.75021 5.31173C7.69405 5.37277 7.63301 5.43381 7.57441 5.49119C7.46575 5.59741 7.34855 5.71461 7.2814 5.82204C7.51703 5.86599 7.73922 5.95756 7.93822 6.09063L10.9622 8.12944C11.3053 8.36017 11.4518 8.75451 11.3358 9.13175C11.2125 9.53585 10.8267 9.80687 10.3762 9.80687ZM6.92126 6.40072C6.68197 6.40316 6.44635 6.47763 6.25956 6.60949L3.37227 8.64097C3.21234 8.75329 3.22577 8.88758 3.24774 8.95717C3.28315 9.06826 3.40157 9.19645 3.62254 9.19645H10.3762C10.5984 9.19645 10.7181 9.06582 10.751 8.95472C10.773 8.88392 10.7852 8.74718 10.6204 8.63608L7.59516 6.59728C7.40349 6.46787 7.1642 6.39828 6.92248 6.40072C6.92248 6.40072 6.92248 6.40072 6.92126 6.40072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocker);
export default __webpack_public_path__ + "static/media/icon-locker.6042a1bb345d0a397aabee14ac4aab86.svg";
export { ForwardRef as ReactComponent };